import { render } from "./ErrorMsg.vue?vue&type=template&id=675d4354&scoped=true"
import script from "./ErrorMsg.vue?vue&type=script&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&lang=js"

import "./ErrorMsg.vue?vue&type=style&index=0&id=675d4354&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-675d4354"

export default script